export function isCoupleAvailable(hasCouple, couple) {
  return Boolean(hasCouple && couple);
}

export function isAdminRole(userRole) {
  return userRole === "admin";
}

export function canEditCouple(hasCouple, couple, userRole) {
  if (!isCoupleAvailable(hasCouple, couple)) {
    return false;
  }

  return isAdminRole(userRole) || Boolean(couple.privacy?.allowPartnerEdit);
}

export function canDeleteCouple(hasCouple, couple, userRole) {
  if (!isCoupleAvailable(hasCouple, couple)) {
    return false;
  }

  return isAdminRole(userRole) || Boolean(couple.privacy?.allowPartnerDelete);
}
